import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import CorporateNavbar from '@/components/CorporateNavbar';
import CorporateFooter from '@/components/CorporateFooter';
import EtherealBackground from '@/components/EtherealBackground';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div 
      className="min-h-screen flex flex-col relative"
      style={{ backgroundColor: '#FDFDFD' }}
    >
      <EtherealBackground />
      <div className="relative z-10">
        <CorporateNavbar />
        
        <div className="flex items-center justify-center min-h-screen py-20">
          <div 
            className="text-center p-12 rounded-3xl"
            style={{
              background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(167, 84, 255, 0.1) 100%)',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.6)',
              boxShadow: '0 8px 32px rgba(167, 84, 255, 0.15)',
              maxWidth: '600px'
            }}
          >
            <h1 className="text-6xl md:text-8xl font-bold mb-6" style={{ color: '#A754FF' }}>
              404
            </h1>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
              Sidan hittades inte
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Oops! Den sida du letar efter finns inte.
            </p>
            <Link 
              to="/" 
              className="inline-block text-white px-8 py-4 rounded-xl text-lg font-medium transition-all hover:scale-105"
              style={{
                backgroundColor: '#A754FF',
                boxShadow: '0 4px 16px rgba(167, 84, 255, 0.3)'
              }}
            >
              Tillbaka till startsidan
            </Link>
          </div>
        </div>
        
        <CorporateFooter />
      </div>
    </div>
  );
};

export default NotFound;